module.exports = __webpack_public_path__ + "static/media/us.218f936f.png";